import { adalApiFetch } from "../security/security";
import { loaderStatus } from "../shared/loader/loader";
import { eventEmitter } from "../utils/eventEmitter";
import i18n from "../i18n";

export async function getAsync(url: string) {
  try {
    loaderStatus.next(true);
    const reply = await adalApiFetch(url);

    if (!reply.ok) {
      throw reply;
    }

    return reply;
  } catch (error) {
    handleError(error);
    throw error;
  } finally {
    loaderStatus.next(false);
  }
}

export async function postAsync(
  url: string,
  payload: any,
  method: "POST" | "PUT" | "DELETE" = "POST"
) {
  try {
    loaderStatus.next(true);

    const reply = await adalApiFetch(url, {
      method,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!reply.ok) {
      throw reply;
    }

    return reply;
  } catch (error) {
    handleError(error);
    throw error;
  } finally {
    loaderStatus.next(false);
  }
}

export async function postFormAsync(
  url: string,
  formData: FormData,
  method: "POST" | "PUT" | "DELETE" = "POST"
) {
  try {
    loaderStatus.next(true);

    const reply = await adalApiFetch(url, {
      method,
      body: formData
    });

    if (!reply.ok) {
      throw reply;
    }

    return reply;
  } catch (error) {
    handleError(error);
    throw error;
  } finally {
    loaderStatus.next(false);
  }
}

function handleError(error: any) {
    if (error.status === undefined) {
        eventEmitter.emit("showModalNotification", {
            title: i18n.Global.Session.SessionExpired,
            message: i18n.Global.Session.SessionExpiredMessage,
        });
    } // else {
        // eventEmitter.emit("showModalNotification", {
        //    title: "Network Error",
        //    message: `Network error: ${error.status} ${error.statusText}`,
        // });
    // }
}


// WEBPACK FOOTER //
// ./src/utils/net.ts